const resizeImageSW = async (file: Blob, maxWidth: number): Promise<Blob> => {
  const imageBitmap = await createImageBitmap(file)
  const canvas = new OffscreenCanvas(imageBitmap.width, imageBitmap.height)

  // Only resize if image is larger than maxWidth
  const scale = imageBitmap.width > maxWidth ? maxWidth / imageBitmap.width : 1
  canvas.width = imageBitmap.width * scale
  canvas.height = imageBitmap.height * scale

  const ctx = canvas.getContext('2d')
  if (!ctx) {
    throw new Error('Failed to get canvas context')
  }

  ctx.drawImage(imageBitmap, 0, 0, canvas.width, canvas.height)
  return canvas.convertToBlob({
    type: file.type,
    quality: 0.7, // compression quality
  })
}

export default resizeImageSW
